import { render, staticRenderFns } from "./AS_FAQ.vue?vue&type=template&id=88b043fe&scoped=true&"
import script from "./AS_FAQ.vue?vue&type=script&lang=js&"
export * from "./AS_FAQ.vue?vue&type=script&lang=js&"
import style0 from "./AS_FAQ.vue?vue&type=style&index=0&id=88b043fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b043fe",
  null
  
)

export default component.exports